module.exports = __webpack_public_path__ + "./fonts/PlayfairDisplay-Bold.ttf";